
export const UtilDateToDayConvert = (dateString) => {
  const date = new Date(dateString + 'T00:00:00Z'); // Ensuring the date is treated as UTC
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const dayOfWeek = days[date.getUTCDay()];
  const dayOfMonth = date.getUTCDate();
  return `${dayOfWeek} ${dayOfMonth}`;
}
